import { render, staticRenderFns } from "./AuditrailReport.vue?vue&type=template&id=1dd513f2&scoped=true"
import script from "./AuditrailReport.vue?vue&type=script&lang=js"
export * from "./AuditrailReport.vue?vue&type=script&lang=js"
import style0 from "./AuditrailReport.vue?vue&type=style&index=0&id=1dd513f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd513f2",
  null
  
)

export default component.exports